export const asociatii = [
  { id: 0, name: 'ACBCR' },
  { id: 1, name: 'Junii bucovinei' }
];
